import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "./Layout";
import Searchicon from "../components/searchicon";
import HomeIcon from "../assets/icons/home_icon";
import axios from "axios";
import config from "../config";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";

import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"; // British format

registerLocale("en-GB", enGB);

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [activeTab, setActiveTab] = useState("All Orders");
  const [currentDate, setCurrentDate] = useState("");
  const [oneMonthBefore, setOneMonthBefore] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedFilterUser, setSelectedFilterUser] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("")

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const ORDERS_PER_PAGE = 10;

  const locations = ["Sydney CBD", "Castle Hill"];
  // console.log(orders)


  useEffect(() => {
    
    const fetchOrders = async () => {
      try {
        const response = await axios.get(
          `${config.BASE_URL}/api/v1/orderList`, {
          params: {
            status: activeTab === "All Orders" ? undefined : activeTab,
            location: selectedLocation || undefined,
            orderNo: searchQuery || undefined,
            order_by: selectedFilter || undefined,
            team_member: selectedFilterUser || undefined, // 👈 NEW
            delivery_priority: selectedPriority || undefined,
            page: currentPage,
            limit: ORDERS_PER_PAGE
          }
        }
        );

        setOrders(response.data.orders);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, [activeTab, selectedLocation, searchQuery, selectedFilter, currentPage, selectedFilterUser, selectedPriority]);

useEffect(() => {
  setCurrentPage(1);
}, [selectedLocation, searchQuery, selectedFilterUser, selectedPriority, activeTab]);


  const navigate = useNavigate();


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleTabClick = (status) => {
    setActiveTab(status);
  };

  const handleRowClick = (orderNo) => {
    navigate(`/edit-order/${orderNo}`);
  };

  // useEffect(() => {
  //   const today = new Date();
  //   const oneMonthAgo = new Date(today.setMonth(today.getMonth() - 1));

  //   setCurrentDate(today.toISOString().split("T")[0]);
  //   setOneMonthBefore(oneMonthAgo.toISOString().split("T")[0]);
  // }, []);

  useEffect(() => {
    const today = new Date();

    // Create a *copy* so we don’t mutate `today`
    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    // Format both as local dates (no timezone shift)
    const formatLocalDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setCurrentDate(formatLocalDate(today));
    setOneMonthBefore(formatLocalDate(oneMonthAgo));
  }, []);

  const handleDateChange = (e, type) => {
    const selectedDate = e.target.value;
    if (type === "start") {
      setOneMonthBefore(selectedDate);
    } else if (type === "end") {
      setCurrentDate(selectedDate);
    }
  };

  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggleDropdown = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };


  const formatDate = (date) => {
    if (!date) return ""; // or return "n/a", "--", etc. if you prefer
    const d = new Date(date);
    if (isNaN(d)) return ""; // additional safety for invalid dates
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear().toString().slice(-4);
    return `${day}/${month}/${year}`;
  };



  const parseDate = (dateStr) => {
    const parsed = new Date(dateStr);
    return isNaN(parsed) ? null : parsed;
  };



  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };



  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateType, setSelectedDateType] = useState("Order Date");

  const handleExportCSV = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams({
        start_date: oneMonthBefore,
        end_date: currentDate,
        date_type: selectedFilter,
        location: selectedLocation,
        team_member: selectedFilterUser,
        delivery_priority: selectedPriority,
      }).toString();

      const response = await fetch(`${config.BASE_URL}/api/v1/export-order-csv?${params}`);
      // console.log(response)
      if (!response.ok) {
        throw new Error("No orders found for the selected date range");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "orders.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      // console.error("Error exporting CSV:", error);
      toast.error("No orders found for the selected date range");
    } finally {
      setIsLoading(false);
    }
  };

  // console.log("selectedLocation: ", selectedLocation);

  return (
    <Layout>
      <div className="orders-page">
        <header className="header">
          <h1>ALL ORDERS</h1>
          <p>
            <Link to="/" className="home-link">
              <HomeIcon />
            </Link>{" "}
            / Orders / All Orders
          </p>
        </header>

        <div className="page_card_body">
          <div className="tabs">
            {["All Orders", "To Place", "Production", "Received", "Delivered"].map((tab) => (
              <button
                key={tab}
                className={`tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="filters">
            <div className="search_field">
              <span className="search-icon">
                <Searchicon />
              </span>
              <input
                type="text"
                placeholder="Search by order number..."
                className="search-input"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
            <div className="export-section">
              <select
                className="dropdown"
                onChange={(e) => setSelectedFilterUser(e.target.value)}
                value={selectedFilterUser}
              >
                <option value="">Filter by User</option>
                <option value="Ajay">Ajay</option>
                <option value="Roshni">Roshni</option>
                <option value="Ajay/indigo">Ajay/indigo</option>
                <option value="Ajay/Raghav">Ajay/Raghav</option>
                <option value="Roshni/indigo">Roshni/indigo</option>
                <option value="Roshni/raghav">Roshni/raghav</option>
                <option value="Indigo">Indigo</option>
                <option value="Raghav">Raghav</option>
                <option value="Raghav/indigo">Raghav/indigo</option>
              </select>



              <span className="export_sectionfieldset_label">EXPORT CSV</span>
              <select className="dropdown" onChange={(e) => setSelectedLocation(e.target.value)}
                value={selectedLocation}
              >
                <option value="">Select location</option>
                <option value="null" disabled selected>Select Location</option>
                <option value="Sydney CBD">Sydney CBD</option>
                <option value="Castle Hill">Castle Hill</option>

              </select>
              <select
                className="dropdown"
                onChange={(e) => setSelectedPriority(e.target.value)}
                value={selectedPriority}
              >
                <option value="">Filter by Priority</option>
                <option value="Super urgent">Super urgent</option>
                <option value="Urgent">Urgent</option>
                <option value="Normal">Normal</option>
              </select>



              <select className="dropdown" onChange={handleFilterChange}
              >
                <option value="">Select Date</option>
                <option selected={selectedFilter === "wedding_date" && "selected"} value="wedding_date">Wedding Date</option>
                <option selected={selectedFilter === "delivery_date" && "selected"} value="delivery_date">Delivery Date</option>
              </select>



              <ReactDatePicker
                selected={parseDate(oneMonthBefore)}
                onChange={(date) => setOneMonthBefore(date.toISOString().split("T")[0])}
                dateFormat="dd/MM/yyyy"
                locale="en-GB"
              />

              <ReactDatePicker
                selected={parseDate(currentDate)}
                onChange={(date) => setCurrentDate(date.toISOString().split("T")[0])}
                dateFormat="dd/MM/yyyy"
                locale="en-GB"
              />

              <button className="export-btn" onClick={handleExportCSV}>Export to CSV</button>
            </div>
            <div className="filter_by_sec">
              <label htmlFor="filter_by">Filter by</label>
              <div className="filter-dropdowns">
                <select
                  className="dropdown"
                  onChange={handleFilterChange}
                  value={selectedFilter}
                >
                  <option value="" disabled>
                    Select Filter
                  </option>
                  <option value="orderDate">Order Date</option>
                  <option value="wedding_date">Wedding Date</option>
                  <option value="delivery_date">Delivery Date</option>
                </select>
              </div>

              <div className="order_filter_item">
                <button
                  className="dropdown-toggle"
                  onClick={() => toggleDropdown("filterLocation")}
                >
                  {selectedLocation || "Select Location"}
                </button>
                {activeDropdown === "filterLocation" && (
                  <div className="filter_dropdown">
                    {locations?.map((location) => (
                      <button
                        key={location}
                        className="dropdown_item"
                        onClick={() => {
                          setSelectedLocation(location);
                          setActiveDropdown(null);
                        }}
                      >
                        {location}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* <select
    className="dropdown"
    onChange={(e) => setSelectedPriority(e.target.value)}
    value={selectedPriority}
  >
    <option value="">All Priorities</option>
    <option value="Super urgent">Super urgent</option>
    <option value="Urgent">Urgent</option>
    <option value="Normal">Normal</option>
  </select> */}




            </div>
          </div>

          <div className="table_outer_for_scroll">
            <table className="orders-table common_table">
              <thead>
                <tr>
                  <th>Customer</th>
                  <th>Order No</th>
                  <th>Order Date</th>
                  <th>Delivery Date</th>
                  <th>Wedding Date</th>
                  <th>Status</th>
                  <th>Priority</th>
                </tr>
              </thead>
              <tbody>
                {orders?.map((order, index) => (
                  <tr
                    key={index}
                    onClick={() => handleRowClick(order._id)}
                    className="clickable-row"
                  >
                    <td>{order?.customer_id?.customer_name}</td>
                    <td>{order.order_no}</td>
                    <td>{formatDate(order.order_date)}</td>
                    <td>{formatDate(order.delivery_date)}</td>
                    <td>{formatDate(order.wedding_date)}</td>
                    <td>{order.status}</td>
                    <td>{order?.delivery_priority}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <Pagination
          variant="outlined" shape="rounded"
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
        />
      </div>



    </Layout>
  );
};

export default OrdersPage;
